import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/Footer.css";
import logo from "../assets/images/Logo-OPMS.webp";
import politicas from "../assets/documents/politica-datos.pdf";

const Footer = ({ traducciones }) => {
  return (
    <footer className="footer-container">
      <Container fluid className="container-custom">
                                <Row className="align-items-center mb-5">
                  <Col
                    xs={12}
                    md={4}
                    className="mb-3 mb-md-0 text-center text-md-start"
                  >
                    <div className="slogan-container">
                      <div className="logotipo mt-3">
                        {traducciones.footer
                          ? traducciones.footer.slogan
                          : "Soluciones efectivas para energía segura."}
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={8}>
                    <nav>
                      <ul className="list-unstyled d-flex flex-column flex-md-row justify-content-center justify-content-md-end gap-3">
                        <li>
                          <a href="#servicios">
                            {traducciones.header
                              ? traducciones.header.servicios
                              : "Servicios"}
                          </a>
                        </li>
                        <li>
                          <a href="#sobre">
                            {traducciones.header
                              ? traducciones.header["sobre-nosotros"]
                              : "Sobre nosotros"}
                          </a>
                        </li>
                        <li>
                          <a href="#como">
                            {traducciones.header
                              ? traducciones.header["como-trabajamos"]
                              : "¿Cómo trabajamos?"}
                          </a>
                        </li>
                        <li>
                          <a href="#trayectoria">
                            {traducciones.header
                              ? traducciones.header.trayectoria
                              : "Trayectoria"}
                          </a>
                        </li>
                        <li>
                          <a href="#contacto">
                            {traducciones.header
                              ? traducciones.header.contacto
                              : "Contacto"}
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </Col>
                </Row>
        <Row className="mt-4">
          <Col className="politica-container">
            <button
              className="politica-button btn btn-primary"
              onClick={() => {
                const nuevaVentana = window.open();
                nuevaVentana.document.write(
                  `<embed src="${politicas}" width="100%" height="100%" type="application/pdf">`
                );
              }}
            >
              {traducciones.footer
                ? traducciones.footer.politica
                : "Política de tratamiento de datos personales"}
            </button>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col className="text-center">
            <div className="copy-bar">
              <div className="copyright">
                {traducciones.footer
                  ? traducciones.footer.copyright
                  : "Copyright © OPMS Consulting. Todos los Derechos Reservados"}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
